<template>
    <div class="direct-eprescribe--wrapper">
        <direct-referral-form
            v-if="!showAncillaryTests"
            :eprescribe="true"
            :activePracticeType="practiceType"
            @close="goToDashboard"
            @open-test-selection="openTestSelection"
            @add-eprescribe="addEprescribe"
            @match-eprescribe="matchEPrescribe"
        ></direct-referral-form>

        <ancillary-service-tests-table
            v-show="showAncillaryTests"
            :ancillaryServices="ancillaryServices"
            :prefillValues="prefillValues"
            :showHeader="false"
            @ancillary-selection-save="saveChanges"
        ></ancillary-service-tests-table>
        <common-buttons>
            <common-button
                v-if="referralType"
                :label="$t('common.microcopy.cancel')"
                type="link"
                size="large"
                @click="$emit('cancel')"
            ></common-button>
        </common-buttons>
    </div>
</template>

<script>
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'
    import FacilityServicesAPI from 'api/FacilityServicesAPI'
    import DirectReferralForm from 'components/page-elements/referrals/DirectReferralForm'
    import AncillaryServiceTestsTable from 'components/page-elements/ancillary-service-tests/AncillaryServiceTestsTable'

    export default {
        components: { DirectReferralForm, AncillaryServiceTestsTable },

        props: {
            practiceType: { type: String, required: true },
            referralType: { type: String, default: null },
        },
        data() {
            return {
                user: null,
                selectedUser: null,
                searchTerm: null,
                insurancePlanId: null,
                testsList: [],
                selectedTests: [],
                PracticeTypeEnum: PracticeTypeEnum,
                showAncillaryTests: false,
                ancillaryServices: [],
                prefillValues: [],
                referral: null,
            }
        },

        computed: {
            searchLabel() {
                return this.practiceType === PracticeTypeEnum.PHYSICIAN
                    ? this.$t('modals.make_direct_referal_modal.physician')
                    : this.$t('modals.make_direct_referal_modal.ancillary')
            },

            searchPlaceholder() {
                return this.$t('modals.make_direct_referal_modal.start_typing')
            },
        },

        methods: {
            userSelected(event) {
                this.selectedUser = event
            },

            removeSearchTerm() {
                this.searchTerm = null
            },

            setSearchTerm({ searchTerm }) {
                this.searchTerm = searchTerm
            },

            itemSelected(item) {
                this.selectedTests.push(item)
                this.testsList = []
                this.$refs.searchAC.searchTerm = ''
                this.$refs.badgeList.calculateMore()
            },

            inputChanged(event) {
                if (event.searchTerm.length < 3) {
                    this.testsList = []
                    return
                }

                FacilityServicesAPI.getFacilityServiceTestSearch({ text: event.searchTerm }).then((response) => {
                    if (response.length > 0) {
                        this.testsList = response
                    } else {
                        this.items = []
                    }
                })
            },

            removeItem(event) {
                const itemIndex = this.selectedTests.map((item) => item.id).indexOf(event.id)
                this.selectedTests.splice(itemIndex, 1)
                this.$refs.badgeList.calculateMore()
            },

            clearTestList() {
                this.testsList = []
            },

            addEprescribe(payload) {
                payload.testsList = this.testsList
                payload.practiceType = this.practiceType
                payload.referralType = this.referralType
                payload.insurancePlanId = payload.insuranceId
                delete payload.insuranceId
                this.$emit('add-eprescribe', payload)
            },

            matchEPrescribe() {
                this.$emit('match-eprescribe')
            },

            openTestSelection(payload) {
                this.referral = payload
                payload.practiceType = this.practiceType
                payload.referralType = this.referralType
                if (payload.practiceType === PracticeTypeEnum.PHYSICIAN) {
                    this.addEprescribe(payload)
                    return
                }
                this.loadAncillary(payload)
            },

            saveChanges(payload) {
                this.referral.testsList = payload
                this.referral.insurancePlanId = this.referral.insuranceId
                this.referral.practiceType = this.practiceType
                this.referral.referralType = this.referralType
                delete this.referral.insuranceId
                this.showAncillaryTests = !this.showAncillaryTests
                this.$emit('add-eprescribe', this.referral)
            },

            goToDashboard() {
                this.$router.push({ name: 'index.home' })
            },

            loadAncillary(payload) {
                const query = {
                    practiceLocationId: payload.practiceLocationId,
                    practiceId: payload.selectedUser.id,
                }
                FacilityServicesAPI.getFacilityServiceGroups(query, [
                    'id',
                    'name',
                    'facilityServiceTypes(id,name,facilityServiceTypesGroups(id,name,typeId,facilityServiceTypesSubgroups(id,name,facilityServiceTests(id,name))))',
                ]).then((response) => {
                    this.ancillaryServices = response.filter((serviceType) => {
                        serviceType.facilityServiceTypes = serviceType.facilityServiceTypes.filter(
                            (service) => service.facilityServiceTypesGroups.length,
                        )
                        serviceType.facilityServiceTypes.map((item) => {
                            item.expanded = false
                        })
                        return serviceType.facilityServiceTypes.some((service) => service.facilityServiceTypesGroups.length)
                    })
                    this.showAncillaryTests = !this.showAncillaryTests
                })
            },
        },
    }
</script>

<style lang="scss">
    .direct-eprescribe--wrapper {
        .card__professional-rating {
            left: 100px;
        }
    }
</style>
